export default __webpack_public_path__ + "static/media/logo-company-16.33b0403f.png";